<template>
  <div class="avue-form">
    <el-form :inline="true" :model="form" ref="refForm"  :rules="formRules">
      <jms-group v-for="(item) in columnOption"
                 :key="item.prop"
                 :display="item.display"
                 :icon="item.icon"
                 :styleType="columnOption.styleType"
                 :expand="columnOption.groupExpand"
                 :label="item.label">
        <template slot="header" v-if="$slots[item.prop+'Header']">
          <slot :name="item.prop+'Header'"></slot>
        </template>
        <template v-if="item.groupSlot">
          <slot :name="item.prop+'Group'" :group="item.column || []"></slot>
        </template>
        <div class="avue-form__group" v-else>
          <template v-for="(column, indexNum) in item.column">
            <div v-if="indexNum && column.inline" :key="indexNum" class="form-dividingline inline"></div>
            <el-form-item :key="column.prop"
                          v-if="validateDisplay(column)"
                          :prop="column.prop"
                          :class="`avue-form__item--${(column.labelPosition || item.labelPosition || '' || column.span === 24 ? 'inline' :column.span ? column.span : '')}`"
                          :label-width="getLabelWidth(column,item)">
              <template slot="label">
                <template v-if="column.tip">
                  <el-tooltip
                      :content="column.tip"
                      :placement="column.tipPlacement || 'right'">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </template>
                <span :title="$lang(column.label)" v-show="column.label">{{$lang(column.label)}}</span>
              </template>
              <template slot="label" v-if="column.labelslot" >
                <slot :name="column.prop + 'Label'"
                      :column="column"
                      :label="form['$'+column.prop]"
                      :form="form"></slot>
              </template>
              <slot :value="form[column.prop]"
                    :column="column"
                    :label="form['$'+column.prop]"
                    :size="column.size || controlSize"
                    :disabled="validateDisabled(column)"
                    :name="column.prop"
                    :form="form"
                    v-if="column.formslot"></slot>
<!--              <el-select v-model="form[column.prop]" v-else-if="column.type ==='select'">-->
<!--                <el-option v-for="(item,index) in column.dicData"-->
<!--                           :key="index"-->
<!--                           :label="column.props ? item[column.props.label] : item.label"-->
<!--                           :value="column.props ? column.props.valueObj ? item : item[column.props.value] : item.value">-->
<!--                </el-option>-->
<!--              </el-select>-->
              <base-select v-model="form[column.prop]" v-else-if="column.type ==='select'" v-bind="column" :dic="column.dicData" :props="column.props" @change="(val) => selectChange(val, column)" :clearable="column.clearable" :disabled="validateDisabled(column)" :size="column.size" :filterable="column.filterable" :remote="column.remote" :remoteMethod="column.remoteMethod" :loading="column.loading" ></base-select>
              <component v-else
                         :ref="column.prop"
                         v-bind="column"
                         v-model="form[column.prop]"
                         :is="getComponent(column.type)"
                         :placeholder="$lang('请输入')"
                         class="bottom-align">
                <template :slot="column.prop+'Type'"
                          slot-scope="{item,label,value}"
                          v-if="column.typeslot">
                  <slot :name="column.prop + 'Type'"
                        :item="item"
                        :value="value"
                        :label="label"></slot>
                </template>
              </component>
            </el-form-item>
            <div v-if="indexNum && column.nextLine || column.inline"
                 :key="indexNum + 1" class="form-dividingline inline"></div>
            <div class="avue-form__line"
                 :key="indexNum"
                 :style="{width:(column.count/24*100)+'%'}"
                 v-if="column.row && column.span!==24 && column.count"></div>
          </template>
        </div>
      </jms-group>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="btnLoading" @click="submitForm">{{ $lang('提交') }}</el-button>
    </div>
  </div>
</template>

<script>
import JmsGroup from '@components/jms-widget/jms-form/components/jmsGroup.vue'
import '@/assets/style/jmsForm.scss'
import { validatenull, vaildData, setPx, arraySort, calcCascader } from '../util/util'
import BaseSelect from '@components/base/BaseSelect.vue'
export default {
  name: 'JmsFormSec',
  components: {
    JmsGroup,
    BaseSelect
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    },
    option: {
      type: Object,
      default: () => {}
    },
    rules: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: '编辑'
    },
    width: {
      type: Number,
      default: 940
    },
    boxType: {
      type: String,
      default: 'add'
    }
  },
  watch: {
    value: {
      handler () {
        this.formVal()
      },
      deep: true
    }
  },
  data() {
    return {
      form: {},
      btnLoading: false,
      formRules: {},
      dialogVisible: false,
      DIC: {}
    }
  },
  computed: {
    columnOption () {
      const list = [...this.option.group] || []
      list.forEach((ele, index) => {
        ele.column = arraySort(ele.column || [], 'formSort')
        ele.column = calcCascader(ele.column)
      })
      return list
    },
  },
  mounted() {
    this.rulesInit()
    this.formVal()
  },
  methods: {
    selectChange(val, column) {
      column.change && column.change(val)
    },
    clearValidate () {
      this.$refs.refForm && this.$refs.refForm.clearValidate()
    },
    validateDisplay (column) {
      if (!validatenull(column.display)) {
        return vaildData(column.display, true)
      } else if (this.boxType === 'add') {
        return vaildData(column.addDisplay, true)
      } else if (this.boxType === 'edit') {
        return vaildData(column.editDisplay, true)
      } else if (this.boxType === 'view') {
        return vaildData(column.viewDisplay, true)
      } else {
        return true
      }
    },
    getLabelWidth (column, item) {
      const result = column.labelWidth || item.labelWidth
      return setPx(result)
    },
    validateDisabled (column) {
      if (this.disabled) return true
      if (!validatenull(column.disabled)) {
        return vaildData(column.disabled, false)
      } else if (this.boxType === 'add') {
        return vaildData(column.addDisabled, false)
      } else if (this.boxType === 'edit') {
        return vaildData(column.editDisabled, false)
      } else if (this.boxType === 'view') {
        return true
      } else {
        return false
      }
    },
    getComponent(type) {
      if (type === 'textarea') {
        return 'el-input'
      } else if (type === 'number') {
        return 'el-input-number'
      }
      return type ? 'el-' + type : 'el-input'
    },
    rulesInit (option) {
      (option || this.columnOption).forEach(ele => {
        if (ele.column && ele.column.length > 0) {
          ele.column.forEach(k => {
            if (k.rules && k.display !== false) { this.$set(this.formRules, k.prop, k.rules) }
            if (Array.isArray(k.dicData)) {
              this.$set(this.DIC, k.prop, k.dicData)
            }
          })
        } else {
          if (ele.rules && ele.display !== false) {
            this.$set(this.formRules, ele.prop, ele.rules)
          }
          if (Array.isArray(ele.dicData)) {
            this.$set(this.DIC, ele.prop, ele.dicData)
          }
        }
      })
      this.$nextTick(() => {
        this.clearValidate()
      })
    },
    formVal () {
      Object.keys(this.value).forEach(ele => {
        this.$set(this.form, ele, this.value[ele])
      })
      console.log('form', this.form)
      this.$emit('input', this.form)
    },
    submitForm() {
      this.$refs.refForm.validate(async valid => {
        if (!valid) return
        this.btnLoading = true
        await this.$emit('submit', this.form)
        this.btnLoading = false
      })
    }
  }
}
</script>
<style scoped lang="scss">
.dialog-footer {
  margin: 10px auto;
  .el-button {
    width: 200px;
    height: 40px;
    font-size: 18px;
  }
}
</style>
